<div class='admissions-manager-tab1-part d-flex flex-column gap-3'>
	<application-status-counts-widget></application-status-counts-widget>

	@if(selectedTrimester(); as trimester) {
	<div class="mt-2 flex flex-column gap-2">
		<h4>
			Time until Admissions deadline: <br>
			<countdown-timer-widget [deadlineUTC]="trimester.applicationDeadlineUTC"
				(isDeadlinePassed)="onDeadlineStatusChange($event)">
			</countdown-timer-widget>
		</h4>

		<common-button-row class="mb-2">
			<button class="btn btn-danger" [disabled]="!isDeadlinePassed()" (click)="closeAllApplications()">
				Close all Applications
			</button>
		</common-button-row>

		@if (!isDeadlinePassed()) {
		<div class="info-message mt-1">
			<small class="text-muted">
				The "Close all Applications" button will be enabled after the deadline passes.
			</small>
		</div>
		}
		@if (notSubmittedCount() > 0) {
		<div class="count-message mt-1">
			<small class="text-primary">
				{{notSubmittedCountMessage()}}
			</small>
		</div>
		}
	</div>

	@if(canCloseAdmissions()) {
	<div>
		<common-button-row>
			<button class="btn btn-secondary" (click)="getAccDetailsForTeamAnnouncement(trimester)">Send Team Announcement Email</button>
		</common-button-row>
	</div>
	}
	}
</div>